import { render, staticRenderFns } from "./DefaultLabelTab.vue?vue&type=template&id=a9815452&"
import script from "./DefaultLabelTab.vue?vue&type=script&lang=js&"
export * from "./DefaultLabelTab.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLabelTab.vue?vue&type=style&index=0&id=a9815452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports